import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import type { MonitoredTransfer } from '@mimir/common/dto/transferRequestDtos';
import { reactive } from '../compat/vueCompat';
import { getTransfers } from '../util/api';
import { logErrorAndShowToast } from '../util/uiError';


interface TransferState {
  ongoingDownloads: Record<string, OngoingDownload>;
  ongoingTransfers: MonitoredTransfer[] | null,
}

export const transfer: TransferState = reactive({
  ongoingDownloads: {},
  ongoingTransfers: null,
});

export async function fetchOngoingTransfers(supportTenantId?: string) {
  try {
    const transfers = await getTransfers(supportTenantId);
    transfer.ongoingTransfers = transfers;
  } catch (err) {
    logErrorAndShowToast('Failed to load ongoing transfers.', err, 'ex in fetchOngoingTransfers');
  }
}
